// src/components/common/sidebar/ProfileOptionsMenu.jsx
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import MoreVertIcon from "@mui/icons-material/MoreVert"; // <-- El icono de 3 puntos
import { ListItemIcon, ListItemText } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import React, { useState } from "react";
import { useAuth } from "../../../contexts/AuthProvider.jsx";

const ProfileOptionsMenu = () => {
  const { auth, setAuth } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  // 2. Handlers para abrir y cerrar
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // 3. Handler para el Logout
  const handleLogout = () => {
    console.log("Cerrando sesión...");
    // Aquí llamarías a tu función real de logout
    // logout();
    setAuth(null);
    handleClose();
  };

  return (
    <>
      {/* 4. El botón (IconButton) que abre el menú */}
      <IconButton
        aria-label="opciones de usuario"
        id="profile-button"
        aria-controls={open ? "profile-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        // Le damos el color de texto secundario de Tailwind
        className="text-text-secondary"
      >
        <MoreVertIcon />
      </IconButton>

      {/* 5. El Menú que aparece */}
      <Menu
        id="profile-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{ "aria-labelledby": "profile-button" }}
        // Estas props lo posicionan arriba del botón
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <MenuItem onClick={handleClose}>
          <ListItemIcon>
            <AccountCircleIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Mi Perfil</ListItemText>
        </MenuItem>

        <MenuItem onClick={handleLogout} sx={{ color: "error.main" }}>
          <ListItemIcon>
            <LogoutIcon fontSize="small" color="error" />
          </ListItemIcon>
          <ListItemText>Cerrar Sesión</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

export default ProfileOptionsMenu;
